/**
 * Outbound links that more than one surface points at.
 *
 * The Chrome Web Store URL appears on the landing "Add to Chrome" buttons, in
 * the dashboard's pairing-failure hint, and in the scan-result email. Those are
 * three separate builds, so before this module each kept its own copy and a
 * relisting meant hunting for all of them. They now re-export from here.
 *
 * The backend is Python and its Docker build context is backend/ only, so it
 * cannot import this file; it keeps a literal that
 * scripts/check_release_hygiene.sh pins to the value below.
 */

/**
 * The published extension id. Deterministic across releases because
 * extension/public/manifest.json pins `key`, which is why it can be stated in
 * source rather than left to configuration. The API states the same value as
 * DEFAULT_EXTENSION_IDS in backend/server.py.
 */
export const CHROME_EXTENSION_ID = "hjcdiaohckdjkgbpacfieogmmhkleapk";

/**
 * The published listing, ending in CHROME_EXTENSION_ID.
 *
 * Written flat rather than assembled from the id above so it survives
 * minification as one searchable string; check_release_hygiene.sh asserts the
 * two agree. The `authuser`/`hl` parameters the Web Store adds to a signed-in
 * admin's address bar are deliberately dropped: `authuser=0` breaks the link
 * for anyone whose first Google account is not the one they browse with, and
 * `hl=en` would pin visitors to English instead of their own locale.
 */
export const CHROME_STORE_URL =
  "https://chromewebstore.google.com/detail/complaudax-wcag-eaa-acces/hjcdiaohckdjkgbpacfieogmmhkleapk";

/**
 * The dashboard route that approves a pairing, relative to app.complaudax.com.
 *
 * Three surfaces aim at it and none of them can see the others' copy: the side
 * panel builds the URL it opens (extension/src/lib/pairing.ts), the marketing
 * site's post-install call to action points at it, and the dashboard both
 * declares the route and links to it from Settings. Renaming the route without
 * renaming every copy does not fail a build; it fails a pairing, which is the
 * one flow with no way for the user to route around it.
 */
export const EXTENSION_AUTHORIZE_PATH = "/extension/authorize";
